import { getAdditionalUserInfo, signInWithPopup } from "firebase/auth";
import { CreateNewAccountMailAPI } from "../../../MailAPIs/CreateNewAccountMailAPI";
import AddUserDataInFirebase from "../User/AddUserDataInFirebase";
import GetUserDataFirebase from "../User/GetUserDataFirebase";
import { get, ref, set } from "firebase/database";
import { UpdateNodeIdInFirebase } from "../UpdateNodeIdInFirebase";
import { appleProvider, auth, database } from "../../../Utils/firebase";
import { generateReferralCode } from "../../../Utils/ReferralCodeGenerator";
import SyncReferralMapping from "../User/SyncReferralMapping";

export const LoginWithAppel = async (dispatch, state, referral_code) => {
    try {


        const result = await signInWithPopup(auth, appleProvider);


        // ✅ Use getAdditionalUserInfo() to check if the user is new
        const additionalInfo = getAdditionalUserInfo(result);


        const isNewUser = additionalInfo?.isNewUser;



        // ✅ Get user details
        const user = result.user;
        const authId = user?.uid;
        const input = user?.providerData[0]?.uid;
        const now = user?.metadata?.creationTime;
        const creationDate = new Date(now);

        // Convert to Unix timestamp (milliseconds since 1970)
        const timestampMillis = creationDate.getTime();

        // Or convert to seconds (optional)
        const timestampSeconds = Math.floor(timestampMillis / 1000);
        const socialId = input.replace(/\./g, '');

        const data = {
            name: user.displayName,
            email: user.email || result._tokenResponse.email,
            userPhoto: user?.photoURL,
            social_id: socialId,
            contact: user?.contact,
            user_uid: user?.uid,
            currency: user?.currency || "IND",
            platform: "Website",
            razorpayId: ""
        }

        const firebaseRef = ref(database, `invoiceGenerator/users/${authId}`);
        const firebaseSnapshot = await get(firebaseRef);
        const firebaseData = firebaseSnapshot.val();

        if (isNewUser) {
            CreateNewAccountMailAPI(data?.email, data?.name);

            // Sync referral mapping globally
            const finalReferralCode = await SyncReferralMapping(authId, data, dispatch);

            // save user node with referral code
            await set(ref(database, `invoiceGenerator/users/${authId}/user`), {
                ...data,
                referral_code: finalReferralCode,
                referredBy: referral_code,

            });

            // if user came via someone’s referral
            if (referral_code) {
                await set(ref(database, `invoiceGenerator/referredUsers/${referral_code}/${authId}`), {
                    name: data?.name,
                    email: data?.email,
                    platform: data?.platform,
                    referredBy: referral_code,
                    createdAt: timestampSeconds,
                    acceptedAt: "",
                    status: data?.status || "pending"
                });
            }
        }

        if (firebaseData != null) {
            const userdata = await GetUserDataFirebase(authId)

            if (userdata !== null) {
                // Ensure referral mapping is synced
                const finalCode = await SyncReferralMapping(authId, userdata || data, dispatch);

                data.name = userdata?.name;
                data.email = userdata?.email;
                data.contact = userdata?.contact;
                data.currency = userdata?.currency;
                data.razorpayId = userdata?.razorpayId;
                data.platform = userdata?.platform || "Website";
                data.referral_code = finalCode || userdata?.referral_code || data?.referral_code || "";
            }
            else {
                setTimeout(() => {
                    AddUserDataInFirebase(state, dispatch, authId, data);

                }, [1000]);

            }
        }
        else {

            // await UpdateNodeIdInFirebase(dispatch, authId, socialId)

            const userdata = await GetUserDataFirebase(socialId)

            if (userdata !== null) {
                // Ensure referral mapping is synced
                const finalCode = await SyncReferralMapping(authId, userdata || data, dispatch);

                data.name = userdata?.name;
                data.email = userdata?.email;
                data.contact = userdata?.contact;
                data.currency = userdata?.currency;
                data.razorpayId = userdata?.razorpayId;
                data.platform = userdata?.platform || "Website";
                data.referral_code = finalCode || userdata?.referral_code || data?.referral_code || "";
            }
            else {
                setTimeout(() => {
                    AddUserDataInFirebase(state, dispatch, authId, data);
                }, [1000]);
                // await AddUser(state, dispatch, socialId, userdata);

            }

        }

        return { sucess: true, message: "Login Successfully", data: data };

    } catch (error) {
        return { sucess: false, message: error.message, data: null };
    }
};